import React, { Children } from 'react'
import Select, { components } from 'react-select'
import Icon from '../../assets/icons/index'
const { SelectDown } = Icon
const { ValueContainer, Placeholder, DropdownIndicator } = components
let shouldShowPlaceholder = true
const CustomValueContainer = ({ children, ...props }) => (
	<ValueContainer {...props}>
		{Children.map(children, (child) => {
			if (child && child.type !== Placeholder) {
				return child
			}
			return null
		})}
		{shouldShowPlaceholder && (
			<Placeholder {...props} isFocused={props.isFocused}>
				{props.selectProps.placeholder}
			</Placeholder>
		)}
	</ValueContainer>
)

const CustomDropDownIndicator = ({ children, ...props }) => (
	<DropdownIndicator {...props}>
		{!props.selectProps.isSearchable ? (
			<div className='custom-dropdown'>
				<img src={SelectDown} alt='select down' />
			</div>
		) : (
			<div></div>
		)}
	</DropdownIndicator>
)
const MultiSelect = ({
	options,
	placeholder,
	onBlur,
	onChange,
	value,
	name,
	onInputChange,
	isSearchable = true,
}) => {
	const { Option } = components

	const colourStyles = {
		control: (styles) => ({
			...styles,
			backgroundColor: '(255,0,0)',
			cursor: 'text',
		}),
		menuList: (base) => ({
			...base,
			height: '200px',
			/* width */
			'::-webkit-scrollbar': {
				width: '5px',
				height: '5px',
			},
			/* Track */
			'::-webkit-scrollbar-track': {
				background: '#f1f1f1',
			},
			/* Handle */
			'::-webkit-scrollbar-thumb': {
				background: '#000000',
				borderRadius: '10px',
			},
			/* Handle on hover */
			'::-webkit-scrollbar-thumb:hover': {
				background: '#000000',
			},
		}),
		option: (styles, { isDisabled }) => {
			return {
				...styles,
				backgroundColor: (255, 255, 255),
				color: (255, 255, 255),
				cursor: isDisabled ? 'not-allowed' : 'pointer',
				':active': {
					...styles[':active'],
					backgroundColor: (255, 0, 0),
				},
			}
		},
		multiValue: (styles) => {
			return {
				...styles,
				backgroundColor: '#151b54',
				cursor: 'pointer',
				maxWidth: '150px',
				minHeight: '25px',
			}
		},
		multiValueLabel: (styles) => ({
			...styles,
			color: '#FFFFFF',
		}),
		placeholder: (base) => ({
			...base,
			marginLeft: '5px',
			position: 'static',
			transform: 'none',
		}),
	}

	const CustomSelectOption = (props) => {
		return (
			<Option {...props}>
				<div title={props.data.title}>{props.data.label}</div>
			</Option>
		)
	}

	return (
		<Select
			isMulti
			components={{
				ValueContainer: CustomValueContainer,
				DropdownIndicator: CustomDropDownIndicator,
				IndicatorSeparator: () => null,
				Option: CustomSelectOption,
			}}
			onMenuClose={() => (shouldShowPlaceholder = true)}
			onMenuOpen={() => (shouldShowPlaceholder = false)}
			options={options}
			styles={colourStyles}
			placeholder={placeholder}
			onBlur={onBlur}
			onChange={onChange}
			value={value}
			name={name}
			onInputChange={onInputChange}
			backspaceRemovesValue={false}
			isSearchable={isSearchable}
			isClearable={false}
		/>
	)
}
export default MultiSelect
